import { render } from "./UserBar.vue?vue&type=template&id=c90b42a6&scoped=true"
import script from "./UserBar.vue?vue&type=script&lang=js"
export * from "./UserBar.vue?vue&type=script&lang=js"

import "./UserBar.vue?vue&type=style&index=0&id=c90b42a6&scoped=true&lang=css"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c90b42a6"]])

export default __exports__